import { useState } from "react";

/**
 * 一覧の複数選択。タイムライン・お気に入り・ゴミ箱で同じ形の状態を持つため、
 * トグルと全解除だけの小さなフックにまとめる。
 */
export function useSelection(): {
  selected: ReadonlySet<string>;
  toggle: (id: string) => void;
  /** 渡されたものを丸ごと選択済みにする(表示中の一括選択) */
  selectAll: (ids: Iterable<string>) => void;
  clear: () => void;
} {
  const [selected, setSelected] = useState<ReadonlySet<string>>(new Set());

  function toggle(id: string) {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  }

  function selectAll(ids: Iterable<string>) {
    setSelected(new Set(ids));
  }

  function clear() {
    setSelected(new Set());
  }

  return { selected, toggle, selectAll, clear };
}
